<script>
import { getAndRemoveItem } from '../lib/utils/storage';
import getBrandConfig from '@/lib/utils/get_brand_config';

const _ = { getAndRemoveItem, brandConfig: getBrandConfig() };

export default {
  _,

  async beforeRouteEnter(to, from, next) {
    if (_.brandConfig.allowWorksFor) {
      next('/worksfor');
    } else {
      const returnPath = _.getAndRemoveItem('returnPath');
      next(returnPath || '/app/clients');
    }
  },
};
</script>
